import { useEffect, useMemo, useState } from "react";
import { WizardStep } from "./wizardStep";
import { RdoFileUpload, wizardStepActionType, RdowizardStepType } from "../../type";
import { Footer } from "./footer";
import { Container } from "./container";
import { message } from "../../../../components/toast";
import { INVALID_SHEET_NAME, SELECT_A_FILE } from "../../message";
import { useApp } from "../../../../components/app";
import { getFileData } from "../wizardBox/utility";

const WizardBox = (props: any) => {
    const { api, closeAddUpdate, isUpdate, selectedFunction } = props;
    const app = useApp();
    const [currentStep, setCurrentStep] = useState<RdowizardStepType>(
        RdowizardStepType.BrowserFile
    );
    const [fileUpload, setFileUpload] = useState<RdoFileUpload[]>([]);
    const [FileUploadRefresh, setFileUploadRefresh] = useState<boolean>(false);
    const [refresh, setRefresh] = useState<boolean>(false);
    const [selectedFunctions, setSelectedFunctions] = useState<number[]>([]);
    const [formData, setFormData] = useState({
        name: "",
        startDate: undefined,
        endDate: undefined,
        jobStartWithSubmit: false,
    });
    const [stepValidations, setStepValidations] = useState<{ [key: number]: () => boolean }>({});

    const onFileUpdateRefresh = (status: boolean) => {
        setFileUploadRefresh(status);
    };

    const onFileUpdate = (updatedFiles: RdoFileUpload[]) => {
        setFileUpload(updatedFiles);
        setRefresh(!refresh);
    };

    const onValidateStep = (step: RdowizardStepType, validateFn: () => boolean) => {
        setStepValidations((prev) => ({
            ...prev,
            [step]: validateFn,
        }));
    };

    const onStepUpdate = async (actionType: wizardStepActionType) => {
        switch (actionType) {
            case wizardStepActionType.next: {
                if (currentStep < RdowizardStepType.ReviewAndUpload) {
                    const validateCurrentStep = stepValidations[currentStep];
                    if (validateCurrentStep && !validateCurrentStep()) {
                        message("error", "Please select at least one function to proceed");
                        return;
                    }

                    switch (currentStep) {
                        case RdowizardStepType.BrowserFile: {
                            if (fileUpload.length > 0) {
                                setFileUpload(await getFileData({ fileUpload }));
                                onFileUpdateRefresh(false);
                                break;
                            } else {
                                message("error", SELECT_A_FILE);
                                return;
                            }
                        }
                        case RdowizardStepType.FunctionMap: {
                            if (fileUpload.length > 0) {
                                let invalidMap = fileUpload?.filter((x) => {
                                    if (!x.selectedSheet || x.selectedSheet.length <= 0) {
                                        x.selectedSheet = [{ name: "" }];
                                    }
                                    if (
                                        !x.selectedSheet![0]?.name &&
                                        x.totalSheet &&
                                        x.totalSheet.length === 1
                                    ) {
                                        x.selectedSheet[0].name = x.totalSheet[0].name;
                                    }
                                    return !x.selectedSheet![0]?.name;
                                });
                                if (invalidMap && invalidMap.length > 0) {
                                    message("error", INVALID_SHEET_NAME);
                                    return;
                                }
                                break;
                            }
                            break;
                        }
                        case RdowizardStepType.SheetMap: {
                            break;
                        }
                    }
                    setCurrentStep(currentStep + 1);
                }
                break;
            }
            case wizardStepActionType.back: {
                if (currentStep > RdowizardStepType.BrowserFile) {
                    setCurrentStep(currentStep - 1);
                }
                break;
            }
        }
    };

    return (
        <div className="wizard-box">
            <WizardStep currentStep={currentStep} />
            <Container
                currentStep={currentStep}
                onFileUpdate={onFileUpdate}
                onFileUpdateRefresh={onFileUpdateRefresh}
                api={api}
                app={app}
                isUpdate={isUpdate}
                closeAddUpdate={closeAddUpdate}
                fileUpload={fileUpload}
                refresh={refresh}
                FileUploadRefresh={FileUploadRefresh}
                selectedFunction={selectedFunction}
                selectedFunctions={selectedFunctions}
                setSelectedFunctions={setSelectedFunctions}
                formData={formData}
                setFormData={setFormData}
                onValidateStep={onValidateStep}
            />
            <Footer
                currentStep={currentStep}
                onStepUpdate={onStepUpdate}
            />
        </div>
    );
};

export { WizardBox };